<template>
  <div class="message-cmenu friend">
    <v-menu bottom left v-model="menu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small v-bind="attrs" v-on="on">
          <v-icon class="far fa-ellipsis-vertical grey--text" size="24"></v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          @click="deleteConversation()">
          <v-list-item-title>
            <v-icon class="fas fa-trash-can pr-2" size="15"></v-icon>
            <translate>Delete conversation</translate>
          </v-list-item-title>
        </v-list-item>
        <v-list-item 
          v-if="canDisconnect"
          @click="disconnectFriend()">
          <v-list-item-title>
            <v-icon class="fas fa-user-minus pr-2" size="15"></v-icon>
            <translate>Disconnect friend</translate>
          </v-list-item-title>
        </v-list-item>
        <v-list-item 
          v-if="canBlock"
          @click="blockFriend()">
          <v-list-item-title>
            <v-icon class="fas fa-ban pr-2" size="15"></v-icon>
            <translate>Block user</translate>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import ChatService from "@/services/ChatService";
export default {
  name: "ChatMenuMessage",
  props: {
    friend: {type: Object, default: () => {}}
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    canDisconnect() {
      return this.friend.status === FRIEND_STATUS_ACCEPTED 
              || this.friend.status === FRIEND_STATUS_BLOCKED
              || this.friend.status === FRIEND_STATUS_BLOCKING
    },
    canBlock() {
      return !(this.friend.status === FRIEND_STATUS_BLOCKING
              || this.friend.status === FRIEND_STATUS_BLOCKED)
    }
  },
  methods: {
    async deleteConversation() {
      await ChatService.deleteConversation(this.friend.user.id);
      this.$store.dispatch('chat/hideChatBox', this.friend.user.id)
    },
    async disconnectFriend() {
      const result = await ChatService.disconnectFriend(this.friend.user.id);
      if(result.myFriend) {
        this.$store.commit('chat/commitFriend', result.myFriend)
        this.$store.state.toggle.ChatFixedBottom.sendData({
          type: 'blockFriend',
          payload: result.theirFriend
        }, this.friend.user.id)
      } else {
        this.$store.commit('chat/removeFriend', this.friend.user.id)
        this.$store.state.toggle.ChatFixedBottom.sendData({
          type: 'removeFriend',
          payload: this.$store.state.auth.userId
        }, this.friend.user.id)
      }
      this.$store.dispatch('chat/hideChatBox', this.friend.user.id)
    },
    async blockFriend() {
      const result = await ChatService.blockFriend(this.friend.user.id);
      this.$store.commit('chat/commitFriend', result.myFriend)
      this.$store.state.toggle.ChatFixedBottom.sendData({
        type: 'blockFriend',
        payload: result.theirFriend
      }, this.friend.user.id)
    },
  },
};
</script>